import styled from 'styled-components';

export const Bold = styled.span`
    font-weight:bold;
`